import React from 'react';
import { Fragment } from 'react';
import { Row, Col, Container, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Header from '../../components/header';
import Footer from '../../components/footer';
import Head from '../../components/head';
import Item from '../../components/itens/item'


function OrgaosScreen() {
    return (
        <Fragment>
            <Head titulo="Órgãos da Prefeitura de Macuco" />
            <Header />
            <Container>
                <Row xs={1}>
                    <Col xs={{ span: 2, offset: 11 }}>
                        <Link to='/'>
                            <Button type='button' variant='danger'>Voltar</Button>
                        </Link>
                    </Col>
                </Row>
                <br />
                <br />
                <Row xs={1} lg={3}>
                    <Col>
                        <Item
                            titulo={"Secretarias"}
                            descricao={"Veja aqui os horários de funcionamento, os telefones de contato e atribuições de cada uma das secretarias do nosso município."}
                            awesome={"faLandmarkDome"}
                            link={"orgaos/secretarias"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Carta de Serviços ao Cidadão"}
                            descricao={"Veja aqui quais serviços cada secretaria presta e orientações de como solicitar cada um deles."}
                            awesome={"faScroll"}
                            link={"orgaos/carta"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Unidades de Saúde"}
                            descricao={"Veja aqui todas unidades de saúde em nosso município, seu horário de funcionamento e seus contatos."}
                            awesome={"faHospital"}
                            link={"orgaos/locais/saude"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Unidades Escolares"}
                            descricao={"Veja aqui todas unidades de educação em nosso município, seu horário de funcionamento e seus contatos."}
                            awesome={"faSchool"}
                            link={"orgaos/locais/educacao"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Unidades de Assistência Social"}
                            descricao={"Veja aqui todas unidades de assistência social em nosso município, seu horário de funcionamento e seus contatos."}
                            awesome={"faHandsHoldingChild"}
                            link={"orgaos/locais/social"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Quadras e Centros Esportivos"}
                            descricao={"Veja aqui todas quadras e centros esportivos em nosso município, seu horário de funcionamento e seus contatos."}
                            awesome={"faFutbol"}
                            link={"orgaos/locais/esporte"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Unidades Gerais"}
                            descricao={"Veja aqui as demais unidades de atendimento em nosso município, seu horário de funcionamento e seus contatos."}
                            awesome={"faMapLocationDot"}
                            link={"orgaos/locais"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Frota Municipal"}
                            descricao={"Veja aqui listagem de veículos que compõe a frota municipal"}
                            awesome={"faCar"}
                            link={"../transparencia/veiculos"}
                            key={1}
                        />
                    </Col>
                    <Col>
                        <Item
                            titulo={"Plano de Contingência de 2023 de Macuco"}
                            descricao={"Veja aqui o Plano de Contingência Unificado para o biênio 2023/2024 elaborado pela Defesa Civil de nosso município."}
                            awesome={"faTowerBroadcast"}
                            link={"arquivos/docs/Plano-de-Contingencia Macuco-RJ-2023.pdf"}
                            key={2}
                        />
                    </Col>
                </Row>
            </Container>
            <Footer />
        </Fragment>
    );
}

export default OrgaosScreen;